// Hinweis oben in jeder Seite, solange eine Notfall-Durchsage läuft („angezeigt auf 7/8").
import '../styles/emergency-power.css';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useBroadcasts } from '../api/emergency-power';
import { can, useMe } from '../api/queries';
import { Icon } from './Icon';
import { hasFeature } from '../api/features';

export function EmergencyBanner() {
  const { t } = useTranslation();
  const { data: me } = useMe();
  const loc = useLocation();
  const { data } = useBroadcasts({ enabled: can(me, 'devices.read') && !!me?.activeTenantId && hasFeature(me, 'emergency') });
  const active = (data ?? []).filter((b) => b.status === 'active');
  if (!active.length || loc.pathname === '/emergency') return null;
  return (
    <div className="em-banner" role="alert">
      <Icon name="megaphone" />
      <span className="grow">
        {active.map((b) => t('emergency.banner', { title: b.title, shown: b.counts.displayed, total: b.counts.total })).join(' · ')}
      </span>
      <Link to="/emergency">{t('emergency.bannerLink')}</Link>
    </div>
  );
}
